import type { ImageProps } from '@hover/blueprint';
import { Image } from '@hover/blueprint';
import React from 'react';

import type { SelectionButtonProps } from '../SelectionButton';
import { SelectionButton } from '../SelectionButton';

export interface ImageSelectionButtonProps
  extends SelectionButtonProps,
    Pick<ImageProps, 'src' | 'alt'> {
  isSelected?: boolean;
}

const ImageSelectionButton = ({
  alt,
  src,
  ...props
}: ImageSelectionButtonProps) => (
  <SelectionButton {...props}>
    <Image alt={alt} borderRadius="900" height="100%" src={src} width="100%" />
  </SelectionButton>
);
export { ImageSelectionButton };
